module.exports = __webpack_public_path__ + "public/images/scribble-sketch-texture-bg-translucent.1d7d1e703e4893f7da0be084112b7c60.png";